export interface PaintingGenerationSnapshot {
  drawLoading?: boolean;
  paintingChatLoading?: boolean;
  image2promptLoading?: number | boolean;
  dalleCurrentHasGenerate?: boolean;
  /**
   * Task ids describe resumable/background context. They intentionally do not
   * count as proof that the currently visible page is still generating.
   */
  pendingTaskId?: string;
  dallePendingTaskId?: string;
}

interface PaintingGenerationOptions {
  includeImage2Prompt?: boolean;
}

/**
 * Whether the currently mounted painting experience has active foreground work.
 * Background task ids are excluded because they can outlive their page/poller.
 */
export const hasActivePaintingGeneration = (
  snapshot: PaintingGenerationSnapshot,
  options: PaintingGenerationOptions = {},
): boolean =>
  Boolean(
    snapshot.drawLoading ||
      snapshot.paintingChatLoading ||
      snapshot.dalleCurrentHasGenerate ||
      (options.includeImage2Prompt && snapshot.image2promptLoading),
  );
